
import { defineComponent } from 'vue'
import { useStore } from 'vuex'
import Heading from '@/components/Heading.vue'

export default defineComponent(
{
    name: 'RegisterActivationNotice',
    components:
    {
        Heading
    },
    setup()
    {
        // Load vuex:
        const store = useStore()
        // Get registration data:
        const registrationData = store.getters['formData/registrationData']

        // Return data:
        return {
            registrationData
        }
    }
})
